import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { ChartAccountsModels, AccountCategoryModels } from './ChartAccountsModels';

export const AddGlChartOfAccounts = createAsyncThunk(
  'ChartAccounts/AddGlChartOfAccounts',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Finance/AddGlChartOfAccounts', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdatGlChartOfAccounts = createAsyncThunk(
  'ChartAccounts/UpdatGlChartOfAccounts',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Finance/UpdatGlChartOfAccounts', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetGlChartOfAccountsList = createAsyncThunk(
  'ChartAccounts/GetGlChartOfAccountsList',
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get('Finance/GetGlChartOfAccountsList');
      return data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetGlChartOfAccountsById = createAsyncThunk(
  'ChartAccounts/GetGlChartOfAccountsById',
  async (id: string, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(`Finance/GetGlChartOfAccountsById?Id=${id}`);
      return data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAccountCategoryList = createAsyncThunk(
  'ChartAccounts/getAccountCategoryList',
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get('Finance/GetAccountCategoryList');
      return data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  ChartAccountsList: ChartAccountsModels[];
  ChartAccountsById: ChartAccountsModels;
  loading: boolean;
  error: any | null;
  AccountCategoryList: AccountCategoryModels[];
  loading2: boolean;
  error2: any | null;
  //
} = {
  ChartAccountsList: [],
  ChartAccountsById: {} as ChartAccountsModels,
  loading: false,
  error: null,
  //
  AccountCategoryList: [],
  loading2: false,
  error2: null
};

const ChartAccountsSlice = createSlice({
  name: 'ChartAccounts',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      // .addCase(AddGlChartOfAccounts.pending, state => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(AddGlChartOfAccounts.fulfilled, (state, action: PayloadAction<any>) => {
      //   state.loading = false;
      //   state.ChartAccountsList.push(action.payload.data);
      // })
      // .addCase(AddGlChartOfAccounts.rejected, (state, action: PayloadAction<any>) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })

      .addCase(GetGlChartOfAccountsList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(GetGlChartOfAccountsList.fulfilled, (state, action: PayloadAction<ChartAccountsModels[]>) => {
        state.loading = false;
        state.ChartAccountsList = action.payload;
      })
      .addCase(GetGlChartOfAccountsList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      /////
      .addCase(GetGlChartOfAccountsById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(GetGlChartOfAccountsById.fulfilled, (state, action: PayloadAction<ChartAccountsModels>) => {
        state.loading = false;
        state.ChartAccountsById = action.payload;
      })
      .addCase(GetGlChartOfAccountsById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //
      .addCase(getAccountCategoryList.pending, (state, action) => {
        state.loading2 = true;
      })
      .addCase(getAccountCategoryList.fulfilled, (state, action: PayloadAction<AccountCategoryModels[]>) => {
        state.loading2 = false;
        state.AccountCategoryList = action.payload;
      })
      .addCase(getAccountCategoryList.rejected, (state, action: PayloadAction<any>) => {
        state.loading2 = false;
        state.error2 = action.payload;
      });
  }
});

export default ChartAccountsSlice.reducer;
